import { motion } from "framer-motion";

type SectionTitleProps = {
  label: string;
  title: React.ReactNode;
  description: React.ReactNode;
  align?: "left" | "center"; // 정렬 선택
  colorMode?: "light" | "dark" | "white"; // 색상 모드 확장
  labelColor?: string; // 직접 색상 지정 가능
};

export default function SectionTitle({
  label,
  title,
  description,
  align = "center",
  colorMode = "light",
  labelColor,
}: SectionTitleProps) {
  const isDark = colorMode === "dark";
  const isWhite = colorMode === "white";

  const labelTextColor =
    labelColor ||
    (isWhite ? "text-light-10" : isDark ? "text-[#0075FF]" : "text-[#0075FF]");

  const titleTextColor = isWhite
    ? "text-white"
    : isDark
    ? "text-white"
    : "text-black-almostBlack";

  const descTextColor = isWhite
    ? "text-light-10"
    : isDark
    ? "text-softGray-20"
    : "text-midGray-50";

  return (
    // <motion.div
    //   initial={{ opacity: 0, y: 30 }}
    //   whileInView={{ opacity: 1, y: 0 }}
    //   transition={{ duration: 0.8, ease: "easeOut" }}
    //   viewport={{ once: true }}
    //   className={align === "center" ? "text-center" : "text-left"}
    // >
    <div className={align === "center" ? "text-center" : "text-left"}>
      {/* Label */}
      <p
        className={`${labelTextColor} sm:text-xl text-sm tracking-tight`}
        style={{ fontFamily: '"pre-Medium", sans-serif' }}
      >
        {label}
      </p>

      {/* Title */}
      <p
        className={`text-[26px] sm:text-3xl md:text-5xl ${titleTextColor} md:mt-14 md:mb-10 sm:mt-10 sm:mb-5 mt-8 mb-5 leading-9 sm:leading-10 md:leading-16 tracking-tight`}
        style={{ fontFamily: '"pre-Bold", sans-serif' }}
      >
        {title}
      </p>

      {/* Description */}
      <p
        className={`text-base md:text-2xl ${descTextColor} tracking-tight md:leading-10 sm:leading-7 leading-[26px] break-keep`}
        style={{ fontFamily: '"pre-Medium", sans-serif' }}
      >
        {description}
      </p>
    </div>
    // </motion.div>
  );
}
